module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._v("Contact Us: Email:\n        "), _c('a', {
    attrs: {
      "href": "mailto:aquawiz.kh@gmail.com"
    }
  }, [_vm._v("aquawiz.kh@gmail.com ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e05aa09"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 338
// module chunks = 0